<template>
  <div>
    <h1>Help Section</h1>
    <p>Welcome to the help section! Below is the documentation:</p>
    <iframe
      src="/vuepress/index.html"
      width="100%"
      height="800px"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "HelpPage",
};
</script>

  